export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_06.4c7d419c.jpg";